module.exports = __webpack_public_path__ + "img/arrow-down.16586350.svg";